import { UnitDto } from '../context/GlobalContext'
import { useMemo } from 'react'
import useGlobalContext from './useGlobalContext'

type ReturnProps = {
    loaded: boolean
    units: UnitDto[]
    activeUnits: UnitDto[]
}

export default function useUnits(): ReturnProps {
    const { loaded, entities } = useGlobalContext('units')

    const units: UnitDto[] = useMemo(() => entities?.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())) || [], [entities])
    const activeUnits = useMemo<UnitDto[]>(() => units.filter(unit => unit.enabled), [entities])

    return { loaded, units, activeUnits }
}
